export const cleanFileName = (file: string) => {
  let tempCode = file.replace(
    /[\'\"\(\)\[\]\{\}\!\@\#\$\%\^\&\*\+\;\:\-\<\>\?\/\_\\\s]/g,
    ".",
  );
  tempCode =
    tempCode.substring(0, tempCode.lastIndexOf(".")).toLowerCase() ||
    tempCode.toLowerCase();

  return tempCode;
};

export const checkRoseCode = (code: string) => {
  const regex = /[\'\"\(\)\[\]\{\}\!\@\#\$\%\^\&\*\+\;\:\-\<\>\?\/\_\\\s]/g;
  return regex.test(code);
};

export const dynamicPositioning = (
  rangeSelectorAttr: any,
  marginAtrr: any,
  titleAttr: any,
  legendAttr: any,
  chartWidthAttr: any,
  viewMode: boolean,
) => {
  let lastElementY = 0;
  let titleY = 0;

  // set range selector
  const rs = rangeSelectorAttr;
  const hasRangeSelector = !!rs?.options?.enabled;
  const topPadding = 12;
  const titleHeight = titleAttr?.textStr
    ? titleAttr?.alignOptions?.height || 0
    : 0;
  const selectorTop = titleHeight
    ? -marginAtrr[0] - titleHeight - 4
    : -marginAtrr[0] + 4;

  if (hasRangeSelector) {
    rs.options.inputPosition.y = selectorTop;
    rs.options.inputPosition.x = -30; // keep left shift to avoid the hamburger button
    rs.options.buttonPosition.y = selectorTop;

    const isTwoRows = rs.inputGroup?.translateY !== rs.buttonGroup?.translateY;
    const boxHeight = rs.maxDateBox?.height || 0;
    lastElementY = isTwoRows
      ? topPadding + 2 * boxHeight + 20
      : topPadding + boxHeight + 10;
  } else if (viewMode) {
    lastElementY = 0;
  }

  const title = titleAttr;
  if (title.textStr !== "") {
    titleY = lastElementY + 30; // title is offset by fontSize by Highcharts
    lastElementY = titleHeight + lastElementY + 10;
  }

  const legendTranslate = [
    "translate(",
    legendAttr.group.translateX,
    ",",
    lastElementY,
    ")",
  ].join("");

  return {
    titleY,
    marginTop: lastElementY + 10 + legendAttr.legendHeight,
    legendTranslate,
  };
};
